import React, { FC } from 'react'
import { Link } from 'gatsby-plugin-react-i18next'
import Button, { ButtonSizes } from 'src/components/ui/Button'
import { ISectionHeaderActionsProps } from './types'

export const SectionHeaderActions: FC<ISectionHeaderActionsProps> = ({
  ctaText,
  ctaLink,
  ctaHoverText,
  ctaSize = ButtonSizes.large,
  cta2Text,
  cta2Link,
  cta2HoverText,
  cta2Size = ButtonSizes.large,
  onCtaClick,
  onCta2Click,
  center = false,
  contentOnly = false,
  ctaRef,
  className = '',
  isStacked = false,
}) => {
  if (!ctaText && !cta2Text) return null

  const renderCtaLink = (
    text?: string,
    link?: string,
    hoverText?: string,
    size: ButtonSizes = ButtonSizes.large,
    isOutline = false,
    onClick?: (e: React.MouseEvent) => void
  ) => {
    if (!text || !link) return null

    const handleAnchorClick = (e: React.MouseEvent) => {
      onClick?.(e)
      if (link.startsWith('#')) {
        const targetElement = document.querySelector(link)
        if (targetElement && (window as any).lenis) {
          e.preventDefault()
          ;(window as any).lenis.scrollTo(targetElement, { duration: 1.5, offset: 0 })
        }
      }
    }

    const buttonElement = (
      <Button className="w-full md:w-auto" isOutline={isOutline} hoverChildren={hoverText} size={size}>
        {text}
      </Button>
    )

    if (/^(https?:)?\/\//.test(link)) {
      return (
        <a href={link} target="_blank" rel="noreferrer" className="flex w-full md:w-auto" onClick={onClick}>
          {buttonElement}
        </a>
      )
    }

    if (link.startsWith('#')) {
      return (
        <a href={link} className="flex w-full md:w-auto" onClick={handleAnchorClick}>
          {buttonElement}
        </a>
      )
    }

    return (
      <Link to={link} className="flex w-full md:w-auto" onClick={onClick}>
        {buttonElement}
      </Link>
    )
  }

  const alignClass = center
    ? 'justify-center'
    : isStacked
      ? 'justify-start md:justify-end'
      : 'justify-start md:justify-start'
  const opacityClass = contentOnly ? '' : 'opacity-0'

  return (
    <div
      ref={ctaRef}
      className={`flex flex-col ${isStacked ? '' : 'md:flex-row'} ${center ? 'items-center' : 'items-start'} ${isStacked ? 'md:items-end' : 'md:items-start'} ${alignClass} gap-4 w-full md:w-auto ${opacityClass} ${className}`}
    >
      {renderCtaLink(ctaText, ctaLink, ctaHoverText, ctaSize, false, onCtaClick)}
      {renderCtaLink(cta2Text, cta2Link, cta2HoverText, cta2Size, true, onCta2Click)}
    </div>
  )
}

export default SectionHeaderActions
